// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_lj-1";
export var rowFirst = "_lj-3";
export var rowLast = "_lj-5";
export var rowMiddle = "_lj-4";
export var ticketListScroll = "_lj-2";
export var ticketStack = "_lj-0";